<template>
  <tr>
    <td v-if="!disableItems">
      <button class="btn btn-light-danger btn-icon btn-xs" title="Eliminar" @click="onRemoveItem">
        <i class="fa fa-fw fa-trash-alt"></i>
      </button>
    </td>
    <td>
      <template v-if="disableItems">
        {{ row.descripcion }}
      </template>
      <InputText v-else v-model="row.tempDescripcion" :vid="`descripcion_${row.id}`" :errorMode="'tooltip'" :inputClass="'form-control form-control-table'" name="Descripción" rules="required"></InputText>
    </td>
    <td class="text-truncate" :title="tipoIgv && tipoIgv.nombre">
      {{ tipoIgv && tipoIgv.nombre }}
    </td>
    <td class="text-right">
      <template v-if="disableItems">
        {{ row.cantidad | number(2) }}
      </template>
      <InputText v-else v-model="row.tempCantidad" :vid="`cantidad_${row.id}`" :errorMode="'tooltip'" :inputClass="'form-control form-control-table text-right'" name="Cant." rules="required|number|greater:0"></InputText>
    </td>
    <td class="text-right">
      <template v-if="disableItems">
        {{ row.precioUnitario | number(2) }}
      </template>
      <InputText v-else v-model="row.tempPrecioUnitario" :vid="`precioUnitario_${row.id}`" :errorMode="'tooltip'" :inputClass="'form-control form-control-table text-right'" name="Cant." rules="required|number|greater:0"></InputText>
    </td>
    <td class="text-right">
      {{ row.valorUnitario | number(2) }}
    </td>
    <td class="text-right">
      {{ row.igv | number(2) }}
    </td>
    <td class="text-right">
      {{ row.subtotal | number(2) }}
    </td>
    <td class="text-right">
      {{ row.total | number(2) }}
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import InputSelect from "../../shared/components/InputSelect.vue";
import InputText from "../../shared/components/InputText.vue";
export default {
  components: { InputText, InputSelect },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters("comprobante2", ["containers", "disableItems", "tipoIgv", "afectaIgv"]),
  },
  watch: {
    "row.tempCantidad": {
      handler() {
        this.onChangeCantidadYPrecio();
      },
      immediate: true,
    },
    "row.tempPrecioUnitario": {
      handler() {
        this.onChangeCantidadYPrecio();
      },
      immediate: true,
    },
    afectaIgv: {
      handler() {
        this.onChangeCantidadYPrecio();
      },
      immediate: true,
    },
  },
  methods: {
    onRemoveItem() {
      this.$store.dispatch("comprobante2/removeItem", this.row.id);
    },
    onChangeCantidadYPrecio() {
      let cantidad = Number(String(this.row.tempCantidad || "").trim());
      cantidad = isNaN(cantidad) ? 0 : cantidad;

      let precioUnitario = Number(String(this.row.tempPrecioUnitario || "").trim());
      precioUnitario = isNaN(precioUnitario) ? 0 : precioUnitario;

      const valorUnitario = this.afectaIgv ? precioUnitario / 1.18 : precioUnitario;
      const subtotal = valorUnitario * cantidad;
      const total = precioUnitario * cantidad;
      const igv = total - subtotal;

      this.row.valorUnitario = valorUnitario.toFixed(2);
      this.row.subtotal = subtotal.toFixed(2);
      this.row.igv = igv.toFixed(2);
      this.row.total = total.toFixed(2);
    },
  },
};
</script>

<style></style>
